/**
 * Hub71 helpdesk public routes. Imported into apps/web/src/routes/index.tsx
 * as a sibling of <RequireAuth> — these routes are anonymous and
 * iframe-embeddable from assist.hub71.com.
 */

import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";

const Hub71Shell = lazy(() => import("./Hub71Shell").then((m) => ({ default: m.Hub71Shell })));
const Hub71ChatPage = lazy(() => import("./Hub71ChatPage").then((m) => ({ default: m.Hub71ChatPage })));

function Hub71Loader() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#FFFFFF" }}>
      <span style={{ fontSize: 12, color: "#8A8A92", letterSpacing: "0.1em", textTransform: "uppercase" }}>
        Loading
      </span>
    </div>
  );
}

export const hub71Routes: RouteObject[] = [
  {
    path: "/hub71help",
    element: (
      <Suspense fallback={<Hub71Loader />}>
        <Hub71Shell />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Hub71Loader />}>
            <Hub71ChatPage />
          </Suspense>
        ),
      },
    ],
  },
];
